<ngb-toast *ngIf="user && is_impersonation" class="mx-auto fixed-top mt-5">
    Currently impersonating {{ user.full_name }}
</ngb-toast>